var map = {
	"./docs.scss": "./source/docs/docs.scss",
	"./elements/docblock/docblock.js": "./source/docs/elements/docblock/docblock.js",
	"./elements/docblock/docblock.scss": "./source/docs/elements/docblock/docblock.scss",
	"./elements/docblock/examples.js": "./source/docs/elements/docblock/examples.js",
	"./elements/docsidebar/docsidebar.js": "./source/docs/elements/docsidebar/docsidebar.js",
	"./elements/docsidebar/docsidebar.scss": "./source/docs/elements/docsidebar/docsidebar.scss",
	"./elements/doctitle/doctitle.scss": "./source/docs/elements/doctitle/doctitle.scss",
	"./elements/list-of-icons/list-of-icons.scss": "./source/docs/elements/list-of-icons/list-of-icons.scss",
	"./elements/proptable/proptable.scss": "./source/docs/elements/proptable/proptable.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./source/docs sync recursive ^(?%21.*_.*).*\\.(scss|js)$";